import { ReactNode, useMemo } from 'react';
import { NavLink, useMatch, useResolvedPath } from 'react-router-dom';

import './styles.scss';

interface Props {
    id: string;
    route: string;
    icon: ReactNode;
    activeIcon: ReactNode;
    text: string;
    count?: number;
    className?: string;
    highlight?: boolean;
}

export const NavigationItem = ({ id, route, icon, activeIcon, text, count, highlight, className = '' }: Props) => {
    const resolvedPath = useResolvedPath(route);
    const isActive = useMatch({ path: resolvedPath.pathname, end: true });

    const counter = useMemo(() => {
        if (!count || count <= 0) {
            return null;
        }

        return <span className='responses-navigation-link__counter'>{`+${count}`}</span>;
    }, [count]);

    return (
        <NavLink to={route} className={`responses-navigation-link ${className}`} end id={id}>
            <div
                className={`responses-navigation-link__icon ${
                    highlight ? 'responses-navigation-link__icon--highlight' : ''
                }`}
            >
                {isActive || highlight ? activeIcon : icon}
            </div>
            <span
                className={`responses-navigation-link__text ${
                    highlight ? 'responses-navigation-link__text--highlight' : ''
                }`}
            >
                {text}
            </span>
            {counter}
        </NavLink>
    );
};
